<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0"></dialogos-app>
            </v-flex>
        </v-layout>
        <!-- botones cancion -->
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page animated fadeIn dura-1">
          <v-flex xs12 md7 sm7 v-for="s in 4" :key="'song'+s">
            <div v-if="letraCancion == s">
            <button v-for="i in 3" class="ml-2 mr-2 hvr" :key="'music'+i" @click="playMusic(s)" :class="{'inactive':inactiveSound[i-1]}"><v-icon color="#084476" size="30">library_music</v-icon></button>
            </div>
          </v-flex>
          <v-flex xs12 md7 sm7 mt-1>
            <h2 class="titulo-descripcion">Letra da canção</h2>
            <v-layout wrap row justify-center align-center text-xs-center class="cont_page">
          <!-- Enumeración -->
          <v-flex class="arrow" xs1>
              <img @click="letraCancion--, verFlecha=true" 
                   v-if="letraCancion>1 " 
                   class="img-arrow" 
                   :src="require('@/assets/imagenes_compartidas/Flecha_verde_izquierda.svg')" 
                   alt="Flecha Izq"
              >  
          </v-flex >
            <v-flex xs4 mt-1 class="acierto animated fadeInUp dura-2">
              <p>{{letraCancion}}/{{4}}</p>
            </v-flex>
          <v-flex class="arrow" xs1>
            <img  
                  @click="letraCancion++,verFlecha=false" 
                  v-if="letraCancion<4" 
                  class="img-arrow "  
                  :src="require('@/assets/imagenes_compartidas/Flecha_verde_derecha.svg')" 
                  alt="Flecha Der"
            >  
          </v-flex > 
          <!-- ./Enumeración -->
        </v-layout>
        </v-flex>
        </v-layout>
        <!-- letra de la cancion -->
        <v-layout wrap row justify-center align-center text-xs-center pb-5 class="cont_page">
          <!-- letra cancion 1 -->
          <v-flex xs12 sm7 md7 class="cont-letra animated fadeInUp" v-show="letraCancion == 1">
            <p> Olha que coisa mais linda <br>Mais 
              <drop-ginga-app :dropList="dropList" valDrop="0" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass">
              </drop-ginga-app>
              de graça <br> É ela a menina <br> que vem e que 
              <span>
              <drop-ginga-app :dropList="dropList" valDrop="1" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass">
              </drop-ginga-app>
              </span><br>Num doce balanço a <br>
              <span>
              <drop-ginga-app :dropList="dropList" valDrop="2" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass">
              </drop-ginga-app>
              </span> do mar
            </p>
          </v-flex>
          <!-- letra cancion 2 -->
          <v-flex xs12 sm7 md7 class="cont-letra animated fadeInUp" v-show="letraCancion == 2">
            <p> Moça do <span>
                <drop-ginga-app :dropList="dropList" valDrop="3" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass">
              </drop-ginga-app>
              </span> dourado <br>do sol de Ipanema <br><span>
                <drop-ginga-app :dropList="dropList" valDrop="4" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass">
              </drop-ginga-app>
              </span> balançado <br>é mais que um poema <br> <span>
                <drop-ginga-app :dropList="dropList" valDrop="5" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass">
              </drop-ginga-app>
              </span> a coisa mais linda <br>que eu <span>
                <drop-ginga-app :dropList="dropList" valDrop="6" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass">
              </drop-ginga-app>
              </span> vi passar

            </p>
          </v-flex>
          <!-- letra cancion 3 -->
          <v-flex xs12 sm7 md7 class="cont-letra animated fadeInUp" v-show="letraCancion == 3">
            <p> Ah, por que estou tão sozinho<br>
              Ah, por que <span>
              <drop-ginga-app :dropList="dropList" valDrop="7" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass"></drop-ginga-app>
            </span> é tão triste
            <br> Ah, a beleza que <span>
              <drop-ginga-app :dropList="dropList" valDrop="8" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass"></drop-ginga-app>
            </span> <br> A beleza<br>que não é só <span>
              <drop-ginga-app :dropList="dropList" valDrop="9" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass"></drop-ginga-app>
            </span><br>Que também passa sozinha
            </p>
          </v-flex>
          <!-- letra cancion 4 -->
          <v-flex xs12 sm7 md7 class="cont-letra animated fadeInUp" v-show="letraCancion == 4">
            <p> Ah, se ela soubesse<br>que 
            <span>
              <drop-ginga-app :dropList="dropList" valDrop="10" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass"></drop-ginga-app>
            </span> ela passa <br>O mundo sorrindo <br>se <span>
              <drop-ginga-app :dropList="dropList" valDrop="11" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass"></drop-ginga-app>
            </span> de graça <br> E fica mais lindo <br>por causa <span>
              <drop-ginga-app :dropList="dropList" valDrop="12" @changeDrop="changeB" :retroaliment="rAliment" :retroalimClass="retroalimClass"></drop-ginga-app>
            </span> amor.
            </p>
          </v-flex>
          <!-- contenedor de los DRAG -->
          <v-flex xs11 mt-1 v-if="mostrarBotones">
              <draggable v-model="dragList" @start="saveEl" class="drag-container" :options="{group:'items'}">
                <div v-for="element in dragList" :key="element">
                  <div class="btn-blue-dark btn-drag hvr" :class="'animated bounceIn dura-'+element+''" >
                    <span v-html="element"></span>
                  </div>
                </div>
              </draggable>
          </v-flex>
          <!-- boton de reiniciar -->
          <v-flex xs10 v-if="!mostrarBotones" class="animated fadeInUp">
            <button class="btn-white-dark" @click="reiniciar()"><span>Reinicar</span></button>
          </v-flex>
        </v-layout>

        <!-- modal Resultado -->
        <modal-resultado-app v-model="modalresultado" :nameResult="modalResult" :fullscreen="true" @bienAvanzar="bienAction()" @malAvanzar="malAction()">
        </modal-resultado-app>
        <!-- cancion  -->
        <audio-player ref="audioPlayer" :autoplay="false" :audios="cancion">
        </audio-player> 
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import draggable from 'vuedraggable'
export default {
  mixins: [nextConditions],
  components: {
      draggable,
  },
  data() {
    return {
      dialogos: [
        'Clique e ouça a música “Garota de Ipanema” e preencha as lacunas.'
      ],
      cancion:['slide19/ibra11-1','slide19/ibra11-2','slide19/ibra11-3','slide19/ibra11-4'],
      length: 3,
      onboarding: 0,
      toolNum:0,
      bien:false,
      mal:false,
      dragList:[],
      correctas:[
        'cheia',
        'passa',
        'caminho',
        'corpo',
        'O seu',
        'É',
        'já',
        'tudo',
        'existe',
        'minha',
        'quando',
        'enche',
        'do',
      ],
      dropList:Array(13).fill([]),
      modalresultado: false,
      modalResult:'mal',
      actualSlot:null,
      vistos:Array(13).fill(false),
      rAliment:Array(13).fill(true),
      mostrarBotones:true,
      classHover:false,
      retroalimClass:'mal',
      lastElement:'',
      inactiveSound:Array(3).fill(false),
      letraCancion:1,
      countCorrecto:0,
      countIncorrecto:0,
      countTurno:0,
    }
  },
  created() {
    if(this.letraCancion == 1){
      this.dragList = [
        'passa',
        'cheia',
        'caminho',
      ]
    }
    this.dragList.sort(function() {
      return 0.5 - Math.random()
    });
  },
  methods: {
      next () {
        this.onboarding = this.onboarding + 1 === this.length ? 0 : this.onboarding + 1
      },
      prev () {
        this.onboarding = this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1
      },
      playMusic(val){
          this.$refs.audioPlayer.playAudio(val-1)
          this.countTurno += 1
          this.$set(this.inactiveSound,this.countTurno-1,true)
      },
      turno(num){
      },
      saveEl(ev) {
        this.lastElement = ev.item.innerHTML
        console.log(this.lastElement)
      },
      changeB(ev, slotNum , numPag) {
         console.log('asdfasdf '+ ev , slotNum , numPag)
        if(this.dropList[slotNum] == this.correctas[slotNum]){
          this.retroalimClass = 'bien'
          this.next()
          this.countCorrecto += 1
          this.$set(this.vistos,this.countCorrecto-1,true)
          this.$set(this.rAliment,slotNum,false)
          console.log('this.countCorrecto '+this.rAliment)
          if(this.countCorrecto == 3){
            setTimeout(() => {
            this.letraCancion = 2
            console.log(this.dragList)
            this.dragList= ['É','O seu','já','corpo']
            this.length = 4,
            this.onboarding= 0,
            console.log(this.dragList)
            this.datosSong()
            }, 1000);
          }if(this.countCorrecto == 7){
            setTimeout(() => {
            this.letraCancion = 3
            this.dragList =['tudo','existe','minha']
            this.length = 3,
            this.onboarding= 0,
             this.datosSong()}, 1000);
          }if(this.countCorrecto == 10){
            setTimeout(() => {
              this.letraCancion = 4
              this.dragList=['enche','quando','do']
              this.length = 3,
              this.onboarding= 0,
             this.datosSong()}, 1000);
          }
        }else{
          this.dragList.push(ev.added.element)
          this.retroalimClass = 'mal animated fadeOut dura-1'
          setTimeout(() => {
            this.$set(this.dropList,slotNum,'')
            this.retroalimClass = ''
            this.prev()
          }, 1000);
          var todosVistos = this.inactiveSound.every(el => {return el})
          if(todosVistos) {
            this.countIncorrecto += 1
            if(this.countIncorrecto == 2){
              this.mostrarBotones = false
            }
          }
        }
      },
      datosSong(){
        this.countTurno = 0
        this.inactiveSound = Array(3).fill(false)
        this.$refs.audioPlayer.pauseAudio()
      },
      reiniciar(){
        this.retroalimClass = ''
        this.mostrarBotones = true
        this.countIncorrecto = 0
        this.datosSong()
      }
  }
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';

.drag-container{
  width: 100%;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  align-items: center;
}
.btn-drag{
  width: 100px;
  margin: 2px;
  padding: 3px 2px;
  text-align: center;
}
.cont-btn-nextprev{
  position: absolute;
  width: 100%;
  margin: 0 auto;
  padding: 12px;
  top: 25%;
  .btn-slide-next{
    right: 0;
    position: absolute;
    z-index: 2;
  }
  .btn-slide-prev{
    left: 0;
    position: absolute;
    z-index: 2;
  }
}

.item-cont{
  border-bottom: solid #12110B 2px;
  position: relative;
  min-width: 50px;
  width: auto;
  display: inline-block;
  .item-drop{
    background: #FFF;
    border-radius: 4px;
    span{
      color: black;
      margin: 0;
      padding: 0;
    }
  }
}
.cont-letra{
  background: #EDC50066;
  padding: 5px;
  p{
    font-size: 13px;
    text-align: center;
    line-height: 35px;
  }
}
.inactive{
  opacity: 0.5;
  pointer-events: none;
  filter: grayscale(1);
}
.titulo-descripcion{
  font-family: Poppins-Italic;
  font-size: 14px;
}
</style>
